/* ---------------------------------------------------------------------------
   Qué le OFRECE la app al perfil que tiene la sesión.

   Espeja la única regla de autorización del backend (Gate `gestionar-maestros`
   en `AppServiceProvider`): decide por el `codigo` del perfil, nunca por su
   `nombre` — el nombre lo renombra el administrador (RF-C3) y no puede ser la
   identidad sobre la que se decide.

   OJO — esto NO autoriza nada. La autorización vive en la API, que responde
   403 mire lo que mire el menú. Acá se decide qué se DIBUJA, para no ofrecer
   una puerta que el servidor va a cerrar.

   Falla CERRADO: sin perfil (sesión todavía sin resolver, o usuario sin
   sesión) no hay administración. Antes esto era una simulación en memoria que
   arrancaba en Super Admin — todos veían los mantenedores.

   El gating es por PREFIJO de ruta (`/admin`), no por pantalla enumerada:
   agregar una pantalla bajo /admin la deja protegida sin tocar este archivo.
--------------------------------------------------------------------------- */

import type { PerfilDelUsuario } from "@/lib/auth";

/** Código del perfil semilla Super Admin (`Perfil::CODIGO_SUPER_ADMIN` en la API). */
export const CODIGO_SUPER_ADMIN = "SA";

/** Prefijos de ruta reservados al Super Admin: todo lo que cuelga de /admin. */
const RUTAS_SUPER_ADMIN = ["/admin"];

export function esSuperAdmin(perfil: PerfilDelUsuario | null | undefined): boolean {
  return perfil?.codigo === CODIGO_SUPER_ADMIN;
}

/** ¿Este perfil puede entrar a esta ruta? */
export function puedeAcceder(
  perfil: PerfilDelUsuario | null | undefined,
  ruta: string,
): boolean {
  if (esSuperAdmin(perfil)) return true;
  return !RUTAS_SUPER_ADMIN.some(
    (prefijo) => ruta === prefijo || ruta.startsWith(`${prefijo}/`),
  );
}
